import React from "react";
import { getInitialData } from "../service/apiFetch";
import ContentPage from "../components/utils/ContentPage";

export const getStaticProps = async () => {
  const initialData = await getInitialData("admission", {
    contentBlock: "Object",
  });

  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      url: initialData?.url || "",
      error: initialData?.error || "",
    },
  };
};

export default function Admission({ data }) {
  const block = data?.contentBlock?.ADMISSION;
  return (
    <ContentPage
      heading={block?.heading}
      subHeading={data?.contentBlock?.CURRICULUM?.subHeading}
      content={block?.content}
    />
  );
}
